(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vf-custom-embroidery"] && !Shopify.designMode) return;
  try {
    
  function vfcBindForms(){
    document.querySelectorAll('[data-vfc-root]').forEach(function(root){
      var form=root.querySelector('.vfc-form');
      if(!form||form.dataset.bound)return;
      form.dataset.bound='true';
      var style=form.querySelector('[data-vfc-style]');
      var code=form.querySelector('[data-vfc-code]');
      var phone=form.elements.namedItem('contact[phone]');
      var preference=form.elements.namedItem('contact[contact_preference]');
      var button=form.querySelector('button[type=submit]');
      var notes=form.querySelector('[data-vfc-notes]');
      var syncCode=function(){
        if(!style||!code)return;
        code.required=style.value==='Specific style';
      };
      var syncPhone=function(){
        if(phone&&preference)phone.required=preference.value==='Phone';
      };
      if(style){
        style.addEventListener('change',syncCode);
        var requestedStyle=new URLSearchParams(window.location.search).get('style');
        if(requestedStyle){
          style.value='Specific style';
          code.value=requestedStyle.slice(0,250);
        }
        syncCode();
      }
      if(preference){
        preference.addEventListener('change',syncPhone);
        syncPhone();
      }
      form.addEventListener('submit',function(){
        if(notes.dataset.originalNotes===undefined)notes.dataset.originalNotes=notes.value;
        var get=function(name){
          var field=form.elements.namedItem('contact['+name+']');
          if(!field)return 'Not specified';
          if(field.type==='checkbox')return field.checked?'Confirmed':'Not confirmed';
          return field.value&&field.value.trim()?field.value.trim():'Not specified';
        };
        notes.value=[
          'CUSTOM EMBROIDERY QUOTE BRIEF',
          'Project: '+get('project_type')+' | Use: '+get('project_use')+' | Quantity: '+get('estimated_quantity'),
          'Budget: '+get('target_budget')+' | In-hands date: '+get('in_hands_date')+' | Postal code: '+get('delivery_postal_code'),
          'Sourcing: '+get('garment_sourcing')+' | Starting point: '+get('starting_point'),
          'Style/link: '+get('style_code_or_link')+' | Color/sizes: '+get('color_and_sizes'),
          'Artwork status: '+get('artwork_status')+' | Placement: '+get('placement')+' | Design size: '+get('design_size'),
          'Exact wording: '+get('exact_wording')+' | Personalization: '+get('personalization'),
          'Artwork link: '+get('artwork_link')+' | Artwork permission: '+get('artwork_permission'),
          'Design brief: '+get('design_brief'),
          'Contact: '+get('name')+' | Email: '+get('email')+' | Phone: '+get('phone')+' | Preference: '+get('contact_preference'),
          'Additional notes: '+(notes.dataset.originalNotes||'None')
        ].join('\n');
        if(button){
          button.dataset.original=button.textContent;
          button.disabled=true;
          button.textContent=root.dataset.busy;
        }
      });
      root.querySelector('[data-vfc-success]')?.focus();
    });
  }
  vfcBindForms();
  document.addEventListener('shopify:section:load',vfcBindForms);
  window.addEventListener('pageshow',function(){
    document.querySelectorAll('[data-vfc-root]').forEach(function(root){
      var button=root.querySelector('button[type=submit]');
      if(button&&button.dataset.original){
        button.textContent=button.dataset.original;
        button.disabled=false;
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
